export function addAlpha (color: string, opacity: number): string {
  const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255)
  return color + _opacity.toString(16).toUpperCase()
}

export function makeAlphaArr (amount: number) {
  const arr: number[] = []
  const step: number = (1 - 0.07) / (amount - 1)
  for (let i = 0; i < amount; i++) { arr.push(0.07 +(step*i)) }

  return arr.reverse()
}

// export function populateArrayWithAlphaColorValues (someArray: string[]) {
//   const tempDict = {}
//   const hexCode = '#0b4dff'
//   const arraylength = someArray.length
//   const hexArr: number[] = makeAlphaArr(arraylength)
//   if (arraylength == 1) { tempDict[someArray[0]] = addAlpha( hexCode , 1) }
//   else {
//     for (let i=0 ; i<arraylength; i++){
//       tempDict[someArray[i]] = addAlpha( hexCode , hexArr[i])
//     }
//   }
//   return tempDict
// }

export function populateArrayWithAlphaValues (someArray: Array<any>) {
  const tempDict = {}
  const hexCode = '#0b4dff'
  const groupArray = someArray.map(x => x.group)
  const arraylength = groupArray.length
  const hexArr: number[] = makeAlphaArr(arraylength)
  if (arraylength == 1) { tempDict[groupArray[0]] = addAlpha( hexCode , 1) }
  else {
    for (let i=0 ; i<arraylength; i++){
      tempDict[groupArray[i]] = addAlpha( hexCode , hexArr[i])
    }
  }
  return tempDict
}

export function generateHexColorDict (dict) {
  const dataColorsetDict: Record<string, any> = {}
  const hexCodeArr = []
  //const hexCodeArr = ['#8fe0e1', '#ffa995', '#f0ed93', '#aae991', '#f8cf95', '#eb93f0']
  const sortedArray = groupBy(dict, 'group')
  for (let i=0; i<sortedArray.length; i++) { dataColorsetDict[sortedArray[i].key] = hexCodeArr[i] }
  return dataColorsetDict
}

export function minmax (data, high: boolean) {
  const unique = groupBy(data, 'group')
  let min = [0, '']
  let max = [1, '']

  for (let i=0; i < unique.length; i++) {
    const mappedValues = groupBy(data, 'group')[i].values.map(({ value }) => (parseInt(value)))
    const sumValues = mappedValues.reduce(
      ( previousValue: number, currentValue: number ) => previousValue + currentValue,
      0
    )
    if ((sumValues/ mappedValues.length) > min[0]) min = [sumValues/ mappedValues.length, unique[i].key]
    if ((sumValues/ mappedValues.length) < max[0]) max = [sumValues/ mappedValues.length, unique[i].key]
  }

  return { min, max }
}

export function groupBy (xs, key) {
  { return xs.reduce(function (rv, x) {
    const v = key instanceof Function ? key(x) : x[key]
    const el = rv.find((r) => r && r.key === v)

    if (el) el.values.push(x)
    else rv.push({ key: v, values: [x] })
    return rv
  }, []) }
}
